import TimeRange from './../components/sections/intellegence/static.timeRange'
import {
  READY_CHANGE_STORE_ITEMSINTELLEGENCE
} from '../actions/itemsIntellegenceActions'

import { states } from './queriesStates'
import getDates from './../shared/services/date.service'

let momentTimeValue = new Date()
momentTimeValue.setSeconds(0)
momentTimeValue.setMilliseconds(0)

const initialState = {
  dataState: states.NOT_REQUESTED,
  itemsIntellegence: {
    timeRange: TimeRange.inmoment.value,
    momentDate: new Date(),
    momentTime: momentTimeValue,
    rangeStartDate: getDates.getNullTimeDate(new Date()),
    rangeEndDate: getDates.getNullTimeDate(new Date()),
    rangeStartTime: getDates.getNullTimeDate(new Date()),
    rangeEndTime: getDates.getEndDayTimeDate(new Date()),
  }
}

const itemsIntellegenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case READY_CHANGE_STORE_ITEMSINTELLEGENCE: {
      const { name, value } = action.payload
      var itemsIntellegence = Object.assign({}, state.itemsIntellegence)

      typeof (name) === 'object'
        ? name.map((item, index) => {
          itemsIntellegence[item] = value[index]
          return null;
        })
        : itemsIntellegence[name] = value

      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          itemsIntellegence: itemsIntellegence
        }
      )
    }
    default:
      return state
  }
}

export default itemsIntellegenceReducer
